import { useState } from "react";
import ProfileCard from "./ProfileCard";

const ProfileCohortsSection = ({ cohort, cohorts, updateProfileSection }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedCohort, setSelectedCohort] = useState(cohort?.id || "");

  const handleSave = async () => {
    await updateProfileSection({ cohort: selectedCohort });
    setIsEditing(false);
  };

  return (
    <ProfileCard
      title="Cohort"
      isEditing={isEditing}
      onEdit={() => setIsEditing(true)}
      onCancel={() => setIsEditing(false)}
      onSave={handleSave}
    >
      {!isEditing ? (
        <div className="cohort-card">
          <img
            src="/assets/images/Events.png"
            alt="Cohort avatar"
            className="cohort-avatar"
          />

          <div>
            <div className="cohort-name">{cohort?.title || "Crawl"}</div>
            <div className="cohort-meta">India</div>
            <div className="cohort-meta">20k+ members</div>
          </div>
        </div>
      ) : (
        <div>
          <label className="form-label">Choose your cohort</label>
          <select
            className="form-control"
            value={selectedCohort}
            onChange={(e) => setSelectedCohort(e.target.value)}
          >
            <option value="">Select Cohort</option>

            {cohorts.map((c) => (
              <option key={c.id} value={c.id}>
                {c.title} — {c.range}
              </option>
            ))}
          </select>
        </div>
      )}
    </ProfileCard>
  );
};

export default ProfileCohortsSection;
